import { useRef, useLayoutEffect } from 'react';
export function useStateRef(state) {
    const ref = useRef(state);
    useLayoutEffect(() => {
        ref.current = state;
    }, [state]);
    return ref;
}
